export default __webpack_public_path__ + "static/media/topbar-rectangle.dd43cb48.jpg";